import { patch } from '@core/api/baseApi';
import { UpdateProfilePhotoResponse } from '@core/types';

export const updateProfilePhoto = (requestData: FormData): Promise<UpdateProfilePhotoResponse> =>
  patch('/users/profile-photo', requestData);
